import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

const REQ_CHIP_STYLES = {
  REQ: {
    bg: "#FEE2E2",
    color: "#DC2626",
    label: "REQ",
  },
  OPT: {
    bg: "#F3F4F6",
    color: "#6B7280",
    label: "OPT",
  },
  IGN: {
    bg: "#FEF3C7",
    color: "#D97706",
    label: "IGN",
  },
};

const ExpectedColumnsCard = ({ expectedColumns = [], callout = null }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: "#FFFFFF",
        p: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography
          fontSize={14}
          fontWeight={700}
          letterSpacing="0.05em"
          color="text.primary"
          mb={3}
        >
          EXPECTED COLUMNS
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {expectedColumns.map((col, index) => {
            const chipStyle = REQ_CHIP_STYLES[col.req] || REQ_CHIP_STYLES.OPT;

            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  py: 1,
                  borderBottom:
                    index < expectedColumns.length - 1
                      ? `1px solid ${theme.palette.grey[200]}`
                      : "none",
                  gap: 2,
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontFamily:
                      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                    fontSize: 13,
                    fontWeight: 600,
                    color: "text.primary",
                    flex: "0 0 45%",
                    wordBreak: "break-word",
                  }}
                >
                  {col.name}
                </Typography>

                <Typography
                  component="span"
                  sx={{
                    fontFamily:
                      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                    fontSize: 12,
                    color: "text.secondary",
                    flex: 1,
                    textAlign: "left",
                    wordBreak: "break-word",
                  }}
                >
                  {col.type}
                </Typography>

                <Box
                  component="span"
                  sx={{
                    px: "6px",
                    py: "2px",
                    borderRadius: "4px",
                    backgroundColor: chipStyle.bg,
                    color: chipStyle.color,
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: "0.03em",
                    flexShrink: 0,
                  }}
                >
                  {chipStyle.label}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      {callout && (
        <Box
          sx={{
            mt: 4,
            p: 2,
            borderRadius: "4px",
            borderLeft: "4px solid #3B82F6",
            backgroundColor: "#EFF6FF",
          }}
        >
          <Typography fontSize={13} color="#1E40AF" lineHeight={1.5}>
            <strong>{callout.label}:</strong> {callout.text}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

ExpectedColumnsCard.propTypes = {
  expectedColumns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      req: PropTypes.oneOf(["REQ", "OPT", "IGN"]).isRequired,
    }),
  ),
  callout: PropTypes.shape({
    label: PropTypes.string,
    text: PropTypes.string,
  }),
};

export default ExpectedColumnsCard;
